// extracted by mini-css-extract-plugin
module.exports = {"tipOptions":"input-tip_tipOptions__ZJXzM","tipOption":"input-tip_tipOption__VmtO6","selected":"input-tip_selected__IFp8z","tipRow":"input-tip_tipRow__T77It"};